import { MOKA_INVENTORY_API } from 'api/constants';

export const V1_SUPPLIER = `${MOKA_INVENTORY_API}/v1/suppliers`;

export const V1_SUPPLIER_BY_ID = id => `${V1_SUPPLIER}/${id}`;

export const V1_EXPORT_SUPPLIER = `${V1_SUPPLIER}/export`;
